import React from "react";
import { TableLine } from "./table-line";

export const Table = (props) => {
  const {
    spacedFields,
    weightAndBalance,
  } = props;

  return (
    <table>
      <thead>
        <tr>
          <th />
          <th className='text-center'>Weight (lbs)</th>
          <th className='text-center bordered'>Arm (in)</th>
          <th width="17%">Moment <br/>(lbs x In)</th>
        </tr>
      </thead>
      <tbody>
        {spacedFields.map((field, index) => {
          const nextSpacing = !spacedFields[index + 1];

          if (field) {
            return (
              <TableLine
                key={index}
                item={field}
                unit={weightAndBalance.unit}
                nextSpacing={nextSpacing}
              />
            );
          }
          if (!nextSpacing) {
            return (
              <tr key={index} className='space-row'>
                <td colSpan={4} />
              </tr>
            );
          }
          }
        )}
      </tbody>
    </table>
  )}
